import type { Corner } from './instant_popup_storage';

// Which corner each mounted, visible pop-up sits in, so a second pop-up (ERC)
// can step aside instead of rendering on top of the first.
type Listener = () => void;

const held = new Map<string, Corner>();
const listeners = new Set<Listener>();

export const holdCorner = (owner: string, corner: Corner | null): void => {
  if (corner) {
    if (held.get(owner) === corner) return;
    held.set(owner, corner);
  } else if (!held.delete(owner)) {
    return;
  }
  listeners.forEach((l) => l());
};

export const cornerHeldByOther = (owner: string, corner: Corner): boolean =>
  Array.from(held.entries()).some(([o, c]) => o !== owner && c === corner);

export const subscribeCorners = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
